import React from 'react'
import PropTypes from 'prop-types'
import { gridSizesProptypes, gridSizesClassName } from '../utils/gridSizes'

export default function ButtonsGroupComponent(props) {
  let className = `r-buttonsgroup ${gridSizesClassName(props.sizes)}`

  return (
    <div className="row row--end row--actions c-form__actions">
      {props.children}
    </div>
  )
}

ButtonsGroupComponent.propTypes = {
  sizes: gridSizesProptypes()
}